import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { addPnProcedureItem } from '../../../timeline/store/timeline.actions'
import { IAddPnProcedure, IPnProcedureState } from '../store/pnProcedure.types'
import { getPnProcedureSelector } from '../selectors/pnProcedure.selector'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { PnProcedureConstants } from '../store/pnProcedure.constants'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { setAddToTimeLine, setPnProcList } from '../store/pnProcedure.actions'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { cloneDeep, isEqual } from 'lodash'

export function* savePertinentProcedureNegative() {
  const pnProcedureState: IPnProcedureState = yield select(getPnProcedureSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)

  if (!pcrID) return

  const handleCommonFieldsDifferences = (pnProcArray: IPnProcedureState) => {
    if (!pnProcArray?.procedurePNNVs) return pnProcArray
    const procedureTempArray = cloneDeep(pnProcArray)
    const date = pnProcArray.date
    const time = pnProcArray.time
    const pta = pnProcArray.pta
    procedureTempArray.procedurePNNVs?.map((item: IAddPnProcedure) => {
      if (item.date !== date || item.time !== time || item.pta !== pta) {
        item.date = date
        item.time = time
        item.pta = pta
      }
    })
    return procedureTempArray
  }

  try {
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocClone = cloneDeep(pcrDoc)

    if (pcrDocClone.patient?.procedureTypeStateListPNNVs && pcrDocClone.patient.procedureTypeStateListPNNVs.length) {
      const index = pcrDocClone.patient.procedureTypeStateListPNNVs.findIndex(
        (pnProc) => pnProc.key === pnProcedureState?.key
      )

      if (index !== -1) {
        pcrDocClone.patient.procedureTypeStateListPNNVs[index] = handleCommonFieldsDifferences(pnProcedureState)
        if (pcrDocClone.patient.procedureTypeStateListPNNVs[index]) {
          const reduxStateListEqual = isEqual(
            pnProcedureState?.procedurePNNVs,
            pcrDocClone.patient.procedureTypeStateListPNNVs[index].procedurePNNVs
          )
          if (!reduxStateListEqual) {
            yield put(setPnProcList(pcrDocClone.patient.procedureTypeStateListPNNVs[index].procedurePNNVs))
          }
        }
      } else {
        pcrDocClone.patient?.procedureTypeStateListPNNVs.push(pnProcedureState)
      }
    } else {
      pcrDocClone.patient = { ...pcrDocClone.patient, procedureTypeStateListPNNVs: [pnProcedureState] }
    }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocClone)

    yield put(setAddToTimeLine(true))
    yield put(addPnProcedureItem())
  } catch (e) {
    yield put(throwPcrException(`savePertinentProcedureNegative() error: ${e}`))
  }
}

export function* savePertinentProcedureNegativeSaga() {
  yield takeLatest(
    [
      PnProcedureConstants.SAVE_PN_PROCEDURE,
      PnProcedureConstants.SET_DATE,
      PnProcedureConstants.SET_TIME,
      PnProcedureConstants.SET_DATE_TIME,
      PnProcedureConstants.SET_PTA,
    ],
    performWithMutexHOG,
    savePertinentProcedureNegative
  )
}
